import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import { IconType } from '../feedback-message/feedback-message.component';
import { FeedbackWithGoHomeComponent } from '../feedback-with-go-home/feedback-with-go-home.component';

@Component({
  selector: 'app-not-found',
  imports: [CommonModule, FeedbackWithGoHomeComponent],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {
  iconType = input.required<IconType>();
  title = input.required<string>();
  subtitle = input<string>('');
  textLines = input<string[]>([]);
}
